import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}/keep-contact-date`

export default {
  async update (id, params) {
    const response = await Repository.patch(`${resource}/${id}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async list(params) {
    const response = await Repository.get(`${resource}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async create(body) {
    const response = await Repository.post(`${resource}`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async delete(id) {
    const response = await Repository.delete(`${resource}/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updateNotKeepContact(body) {
    const response = await Repository.patch(`${resource}/update-not-keep-contact`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  }
}
